import type { IRowContainerProps } from '../RowContainer.h'

import { useMemo } from 'react'
import { ContainerControls } from 'blocks/Container/Controls'
import { RowControlsType } from '../RowContainer.h'
import { NextControl } from './NextControl'
import { PrevControl } from './PrevControl'

export interface IHeaderControls extends Pick<
  IRowContainerProps,
  'controlsType'
> {
  childrenType?: string
  currentIndex?: number
  nextButtonVisible: boolean
  prevButtonVisible?: boolean
  prev: () => void
  next: () => void
}

export const HeaderControls = ({
  currentIndex,
  nextButtonVisible,
  prevButtonVisible,
  controlsType = RowControlsType.inRowFluid,
  prev,
  next,
}: IHeaderControls) => {
  const controlsState = useMemo(
    () => [
      {
        visible: currentIndex! > 0 || Boolean(prevButtonVisible),
        disabled: false,
      },
      {
        visible: nextButtonVisible,
        disabled: false,
      },
    ],
    [currentIndex, nextButtonVisible, prevButtonVisible]
  )

  return (
    <ContainerControls controlsState={controlsState}>
      <PrevControl controlsType={controlsType} onClick={prev} />
      <NextControl controlsType={controlsType} onClick={next} />
    </ContainerControls>
  )
}
